import SearchToggle from "./SearchToggle";
import FunnelbackSearch from "./FunnelbackSearch";
// Initialise the main navigation component
const mainNavigationElem = document.querySelector("[data-main-nav]");
if (mainNavigationElem) {
    new SearchToggle(mainNavigationElem);
}
const searchInputs = document.querySelectorAll("[data-site-search]");
if (searchInputs.length > 0) {
    searchInputs.forEach((item) => {
        new FunnelbackSearch(item);
    });
}
